import { useTranslation } from 'react-i18next';
import { ExtendedKeyboardEvent } from 'mousetrap';
import { useKeyboardShortcuts } from './useKeyboardShortcuts';

export const useSearchBarShortcuts = (
  handleFocusKeyboardShortcut: (event?: ExtendedKeyboardEvent) => void,
): void => {
  const { t } = useTranslation();
  useKeyboardShortcuts(
    [
      {
        category: 'common',
        description: t('keyboardShortcuts.focusSearchBar'),
        keys: '/',
        handler: handleFocusKeyboardShortcut,
      },
    ],
    [handleFocusKeyboardShortcut],
  );
};
